"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const globals_1 = require("./infra/globals");
globals_1.setup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2Q0FBd0M7QUFFeEMsZUFBSyxDQUFDIn0=